export default "__VITE_ASSET__D138clwf__"